/**
 * Inviting someone to Dō (`POST /api/invite`), one copy for web and mobile.
 * Mobile imports this by subpath.
 */

/**
 * Invitations an account may ever send. The API's ceiling
 * (`SendInvitation::MAX_INVITATIONS_ALLOWED`), which it does not publish; it
 * is the same for every role and plan.
 */
export const APP_INVITATION_LIMIT = 5;

export const APP_INVITATION_COPY = {
  title: 'Invite to Dō',
  /** The mail names the inviter by username, so the dialog says so. */
  lede: (username: string) =>
    `Dō is invitation-only for now. We'll email them a link to create an account, and it will say it's from @${username}.`,
  quotaLabel: 'Invitations',
  fieldLabel: 'Their email',
  placeholder: 'name@example.com',
  /** An accepted invitation befriends nobody (`CreateNewUser` only spends it). */
  help: "An invitation doesn't make you friends. Once they've joined, add them by username.",
  submit: 'Send invitation',
  spentTitle: `You've sent all ${APP_INVITATION_LIMIT} invitations`,
  spentBody: `Each account gets ${APP_INVITATION_LIMIT}. They don't come back if someone never signs up. Anyone you invited can still create an account from their email.`,
  invalidEmail: 'Enter a valid email address.',
  /** Any inviter's earlier invitation counts, so it names nobody. */
  alreadyInvited: 'This address already has an invitation.',
  failedTitle: "Couldn't send the invitation",
  failedBody: 'Something went wrong on our side. Try again in a moment.',
  sentTitle: 'Invitation sent',
  sentBody: (email: string) => `to ${email}`,
} as const;
